import {withStylesProvider} from '../..';

import {StylesProvider} from './theme/context';
import {feedbackLayoutTheme} from './theme/theme';

import {
  FeedbackLayoutBody,
  FeedbackLayoutDescription,
  FeedbackLayoutPlayer,
  FeedbackLayoutTitle,
  FeedbackLayoutInternal,
} from './FeedbackLayout';

type FeedbackLayoutType = typeof FeedbackLayoutInternal & {
  Body: typeof FeedbackLayoutBody;
  Title: typeof FeedbackLayoutTitle;
  Description: typeof FeedbackLayoutDescription;
  Player: typeof FeedbackLayoutPlayer;
};

export const FeedbackLayout = withStylesProvider(
  FeedbackLayoutInternal,
  StylesProvider,
  feedbackLayoutTheme,
) as unknown as FeedbackLayoutType;
export type {FeedbackLayoutProps} from './FeedbackLayout';

export {FeedbackLayoutBody, FeedbackLayoutTitle, FeedbackLayoutDescription, FeedbackLayoutPlayer};

FeedbackLayout.Body = FeedbackLayoutBody;
FeedbackLayout.Title = FeedbackLayoutTitle;
FeedbackLayout.Description = FeedbackLayoutDescription;
FeedbackLayout.Player = FeedbackLayoutPlayer;
